module.exports = __webpack_public_path__ + "img/2.f9eec9cc.jpg";